import { render } from "./CompositionPropertiesTab.vue?vue&type=template&id=bdad6a5c"
import script from "./CompositionPropertiesTab.vue?vue&type=script&lang=js"
export * from "./CompositionPropertiesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__